
import Vue from 'vue';
import Modal from '@/components/Modal.vue';
import SelectPicker from '@/components/SelectPicker.vue';
import { NormalizedFormat } from '@/types/apptypes';
import { Options } from '@/components/SelectPicker.vue';
import { BLUser } from '@/types/blacklabtypes';
import * as Api from '@/api';



export default Vue.extend({
	components: {Modal, SelectPicker},
	props: {
		publicFormats: Array as () => NormalizedFormat[],
		privateFormats: Array as () => NormalizedFormat[],
		loading: Boolean,
		user: Object as () => BLUser
	},
	data: () => ({
		corpusName: '',
		documentType: '',
		errorMessage: '',
	}),
	computed: {
		selectedFormat(): NormalizedFormat|undefined {
			return this.publicFormats?.find(f => f.id === this.documentType) || this.privateFormats?.find(f => f.id === this.documentType);
		},
		formatOptions(): Options {
			const r: Options = [];
			if (this.privateFormats) r.push({label: 'Custom', options: this.privateFormats.map(f => ({value: f.id, label: `${f.displayName} <small class="text-muted">${f.id}</small>`}))});
			if (this.publicFormats) r.push({label: 'Public', options: this.publicFormats.map(f => ({value: f.id, label: `${f.displayName} <small class="text-muted">${f.id}</small>`}))});
			return r;
		}
	},
	methods: {
		createCorpus() {
			if (!this.corpusName) return this.errorMessage = 'Please enter a name for the corpus.';
			if (!this.documentType) return this.errorMessage = 'Please select a document format.';
			if (!this.user?.loggedIn || !this.user?.id) {
				console.error('user not logged in - cannot create corpus (!?)');
				return;
			};

			// Prefix the user name because it's a private index
			const indexName = this.user.id + ':' + this.corpusName.replace(/[\s\\/:]+/g, '_');
			const displayName = this.corpusName;

			Api.blacklab
			.postCorpus(indexName, displayName, this.documentType)
			.then(() => {
				this.$emit('create');
				this.$emit('success', `Corpus "${displayName}" created.`);
			})
			.catch((e: Api.ApiError) => this.$emit('error', `Could not create corpus "${displayName}": ${e.message}`))
			.finally(() => this.$emit('close'));
		}
	}
})

